import { ServicesURL } from "@utils/utilsApi";

export const SEARCH_PARAM_BY_ENDPOINT: Record<string, string> = {
  [ServicesURL.getCertificates]: "name",
  [ServicesURL.getBadges]: "name",
  [ServicesURL.getLTIAccounts]: "accountName",
  [ServicesURL.getCustomer]: "name",

  [ServicesURL.getSurvey]: "name",
  [ServicesURL.getCourses]: "title",
  [ServicesURL.getActivities]: "title",
  [ServicesURL.getPaths]: "title",

  [`${ServicesURL.topics}/:idInitiative/topics`]: "name",

  [`${ServicesURL.categories}/:idInitiative/categories`]: "name",

  [`${ServicesURL.initiative}/:idCorporate/initiatives`]: "name",
  [ServicesURL.library]: "search",
};

const DEFAULT_SEARCH_PARAM = "search";

const matchEndpoint = (url: string): string | undefined => {
  const pathOnly = url.split("?")[0];
  return Object.keys(SEARCH_PARAM_BY_ENDPOINT).find((registered) => {
    const pattern = registered
      .replace(/:[a-zA-Z]+/g, "[^/]+")
      .replace(/\//g, "\\/");
    return new RegExp(`^${pattern}$`).test(pathOnly);
  });
};

export const resolveSearchParam = (
  url: string | null,
  override?: string,
): string => {
  if (override) return override;
  if (!url) return DEFAULT_SEARCH_PARAM;
  const matched = matchEndpoint(url);
  if (matched) return SEARCH_PARAM_BY_ENDPOINT[matched];
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.warn(
      `[usePaginatedList] endpoint "${url.split("?")[0]}" non registrato in ` +
        `searchParamRegistry — uso fallback "${DEFAULT_SEARCH_PARAM}". ` +
        `Probabilmente il BE non lo accetta e la search non filtra.`,
    );
  }
  return DEFAULT_SEARCH_PARAM;
};
